import { render, staticRenderFns } from "./institucionesScreenUsuarios.vue?vue&type=template&id=c7b952f6&scoped=true"
import script from "./institucionesScreenUsuarios.vue?vue&type=script&lang=js"
export * from "./institucionesScreenUsuarios.vue?vue&type=script&lang=js"
import style0 from "./institucionesScreenUsuarios.vue?vue&type=style&index=0&id=c7b952f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b952f6",
  null
  
)

export default component.exports